import React, { useEffect, useState } from 'react'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { withTranslation, Trans } from 'react-i18next'
import {
  useErrorService,
  surveyType,
  PrintableArea,
  buildAggregatedCombinedSummaryFileBase,
} from '@abroad/components'
import {
  WisdomAssessmentResult,
  ProsperityAssessmentResult,
  AwarenessAssessmentResult,
} from '../components'
import API from '../utils/API'

const ViewCompanyAssessment = () => {
  const { companyName } = useParams()
  let history = useHistory()
  const Error = useErrorService()
  const [survey, setSurvey] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const { search } = useLocation()
  const query = new URLSearchParams(search)
  const querySurveyType = query.get('surveyType')
  const pdfFileNameBase = buildAggregatedCombinedSummaryFileBase(
    companyName,
    querySurveyType,
  )

  useEffect(() => {
    const getCompanyAssessment = async () => {
      try {
        const { data } = await API.AdminAPI.companyList.getSurveyByCompanyName(
          companyName,
          search,
        )
        setSurvey(data)
        setIsLoading(false)
      } catch (e) {
        if (
          e?.code === 'ValidationError' ||
          e?.code === 'resource_not_found' ||
          e?.code === 'not_found'
        ) {
          history.replace('/404')
        } else {
          setIsLoading(false)
          Error.showError(e)
        }
      }
    }
    if (companyName) {
      getCompanyAssessment()
    } else {
      history.replace(`/admin/organizations`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Helmet>
        <title>{`${companyName}'s Assessment | Abroad`}</title>
        <meta
          name='title'
          content={`${companyName}'s Assessment | Abroad`}></meta>
        <meta
          property='og:title'
          content={`${companyName}'s Assessment | Abroad`}></meta>
        <meta
          property='twitter:title'
          content={`${companyName}'s Assessment | Abroad`}></meta>
        <link
          rel='canonical'
          href={`${process.env.REACT_APP_DOMAIN}/admin/organization/${companyName}`}></link>
        <meta
          property='og:url'
          content={`${process.env.REACT_APP_DOMAIN}/admin/organization/${companyName}`}></meta>
        <meta
          property='twitter:url'
          content={`${process.env.REACT_APP_DOMAIN}/admin/organization/${companyName}`}></meta>
      </Helmet>
      <main>
        {querySurveyType === surveyType?.WISDOM ? (
          <WisdomAssessmentResult
            survey={survey}
            isLoading={isLoading}
            headerText='Organization Wisdom Assessment'
            subHeaderText={`${decodeURIComponent(
              companyName,
            ).toUpperCase()}'S COMBINED SUMMARY RESULTS`}
            subHeaderDescription='Below are the aggregate results for how your group rated your organization.'
            pdfFileNameBase={pdfFileNameBase}
          />
        ) : querySurveyType === surveyType?.PROSPERITY ? (
          <ProsperityAssessmentResult
            survey={survey}
            isLoading={isLoading}
            headerText='Organization True Prosperity Assessment'
            subHeaderText={`${decodeURIComponent(
              companyName,
            ).toUpperCase()}'S COMBINED SUMMARY RESULTS`}
            subHeaderDescription='Below are the aggregate results for how your group rated your organization.'
            pdfFileNameBase={pdfFileNameBase}
          />
        ) : (
          <AwarenessAssessmentResult
            survey={survey}
            isLoading={isLoading}
            headerText={<Trans>Organizational Awareness Assessment</Trans>}
            pdfTitle='Organizational Awareness Assessment'
            pdfSubtitle={`${decodeURIComponent(
              companyName,
            ).toUpperCase()}'S COMBINED SUMMARY RESULTS`}
            pdfFileNameBase={pdfFileNameBase}
            subHeaderText={
              <Trans>{`${decodeURIComponent(
                companyName,
              ).toUpperCase()}'S COMBINED SUMMARY RESULTS`}</Trans>
            }
            subHeaderDescription={
              <Trans>
                Below are the aggregate results for how your group rated your
                organization.
              </Trans>
            }
          />
        )}
      </main>
      <PrintableArea printSelector='main' />
    </>
  )
}

export default withTranslation('translation')(ViewCompanyAssessment)
